<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">نمایش متریال</h6>
            <button type="button" class="btn btn-outline-success" data-toggle="modal" data-target="#exampleModalCenter" v-if="can('materials.store')">
              ایجاد متریال
            </button>
          </div>

          <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalCenterTitle">ایجاد متریال</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="بستن">
                    <em class="ti-close"></em>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="form-row d-flex justify-content-center">
                    <div class="col-md-8 mb-3">
                      <label for="validationCustom01">نام
                        <span class="text-danger">*</span>
                      </label>
                      <input type="text" class="form-control" placeholder="نام را وارد کنید!" required name="name"
                        v-model="form.name" @keydown="form.errors.clear('name')">
                      <span class="help text-danger" v-if="form.errors.has('name')"
                        v-text="form.errors.get('name')"></span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>
                  <button type="button" class="btn btn-primary" @click="createMaterial('exampleModalCenter')">ذخیره</button>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام</th>
                  <th v-if="can('materials.update')">تنظیمات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(material , index) in data" :key="index">
                  <td>{{index+1}}</td>
                  <td v-text="material.name"></td>
                  <td v-if="can('materials.update')">
                      <button type="button" class="btn btn-outline-warning btn-rounded btn-uppercase" data-toggle="modal" :data-target="'#editmodal' + index" @click="clickOnEdit(material.id)">
                        <em class="fa fa-edit m-r-5"></em> ویرایش
                      </button>
                      <div class="modal fade" :id="'editmodal' + index" tabindex="-1" role="dialog" aria-hidden="true" :ref="'editmodal' + index">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalCenterTitle">ویرایش متریال</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="بستن">
                                <em class="ti-close"></em>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="form-row d-flex justify-content-center">
                                <div class="col-md-8 mb-3">
                                  <label for="validationCustom01">نام
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input type="text" class="form-control" placeholder="نام را وارد کنید!" required name="name" v-model="form2.name"
                                    @keydown="form2.errors.clear('name')">
                                  <span class="help text-danger" v-if="form2.errors.has('name')"
                                    v-text="form2.errors.get('name')"></span>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clickOnClose(material.id)">بستن</button>
                              <button type="button" class="btn btn-primary" @click="editMaterial(material.id, 'editmodal' + index)">ذخیره</button>
                            </div>
                          </div>
                        </div>
                      </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>ردیف</th>
                  <th>نام</th>
                  <th v-if="can('materials.update')">تنظیمات</th>
                </tr>
              </tfoot>
            </table>
            <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
export default {
  name: 'MaterialIndex',
  mixins: [pagination],
  components: {
    paginations
  },
  data () {
    return {
      data: null,
      url: '/api/materials',
      form: new this.$form({
        name: ''
      }),
      form2: new this.$form({
        name: ''
      })
    }
  },
  methods: {
    createMaterial (modal) {
      this.$send.submit('post', 'api/materials', this.form.data())
        .then(response => {
          this.form.onSuccess(response)
          this.data.unshift(response)
          window.$('#' + modal).modal('hide')
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'متریال جدید با موفقیت ایجاد شد!',
            'success'
            , {
              button: 'باشه'
            })
        }).catch(error => {
          this.form.onFail(error.errors)
        })
    },
    clickOnEdit (id) {
      const num = this.data.findIndex(x => x.id === id)
      this.form2.name = this.data[num].name
    },
    clickOnClose (id) {
      this.form2.name = ''
    },
    editMaterial (id, modal) {
      this.$send.submit('patch', 'api/materials/' + id, this.form2.data())
        .then(response => {
          this.form2.onSuccess(response)
          const num = this.data.findIndex(x => x.id === id)
          this.data[num] = response
          window.$('#' + modal).modal('hide')
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'متریال با موفقیت ویرایش شد!',
            'success'
            , {
              button: 'باشه'
            })
        }).catch(error => {
          this.form2.onFail(error.errors)
        })
    }
  }
}

</script>
